var _defs, _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAzureApiManagment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a3",
    x1: 9,
    y1: 16.82,
    x2: 9,
    y2: 1.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#198ab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#1f9dc4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#28b5d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2dc6e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#31d1f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#32d4f5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b3",
    x1: 8.36,
    y1: 11.35,
    x2: 8.36,
    y2: 14.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c69aeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6f4bb2"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.18 5.89a4.85 4.85 0 00-4.95-4.71 5 5 0 00-4.75 3.29A4.61 4.61 0 00.5 9a4.67 4.67 0 004.79 4.5 3 3 0 00.42 0h1.2a1.47 1.47 0 01-.11-.56 1.51 1.51 0 01.2-.73H5.29A3.41 3.41 0 011.77 9a3.33 3.33 0 012.91-3.27l.76-.12.25-.73a3.73 3.73 0 013.54-2.43 3.6 3.6 0 013.68 3.45V7l1.09.15a2.59 2.59 0 012.26 2.49 2.63 2.63 0 01-2.62 2.54h-1.23A3.92 3.92 0 008.54 9a.64.64 0 100 1.27 2.65 2.65 0 010 5.29.64.64 0 100 1.27 3.92 3.92 0 003.87-3.34h1.05a.64.64 0 00.2 0 3.91 3.91 0 003.84-3.85 3.86 3.86 0 00-3.32-3.75z",
    fill: "url(#a)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.8,
    y: 11.35,
    width: 3.12,
    height: 3.12,
    rx: 1.54,
    fill: "url(#b)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureApiManagment);
export default __webpack_public_path__ + "static/media/azure-apiManagment.53bbc96f10d8ecbd33194c0c17b4f892.svg";
export { ForwardRef as ReactComponent };